import React from "react";

import Spinner from "../../../../../../components/Spinner";
import Typography from "../../../../../../components/Text";
import { CardBody, CardHeader } from "../../../../components/Card";
// components
import CohortENPSDetailsTable from "./CohortENPSDetailsTable";

// hooks
import useCohortENPSRows from "./useCohortENPSRows";

// utils
import downloadCSV from "../../../../../../utils/downloadCSV";

// css
import css from "./CohortENPSDetailsTable.module.scss";

const CohortENPSDetails = () => {
	const { rows, isLoading, getCSVContent, selectCSVDownloadName } = useCohortENPSRows();
	return (
		<div>
			<CardHeader
				title={
					<span>
						<Typography element="span" size="paragraph-2" weight="semi-bold">
							Cohort eNPS
						</Typography>
					</span>
				}
				info="The Cohort eNPS Table displays the eNPS score for each active cohort for the selected time period, along with the proportion of promoters, detractors, and passives for that cohort."
				options={
					rows.length
						? [
								{
									id: "download-csv",
									label: "Download CSV",
									action: () => {
										const csvContent = getCSVContent();
										const filename = selectCSVDownloadName();
										downloadCSV(csvContent, filename);
									},
								},
							]
						: undefined
				}
			/>
			<CardBody>
				{isLoading ? (
					<div className={css.emptyContainer}>
						<Spinner />
					</div>
				) : (
					<CohortENPSDetailsTable isLoading={isLoading} rows={rows} />
				)}
			</CardBody>
		</div>
	);
};

export default CohortENPSDetails;
